// extracted by mini-css-extract-plugin
export default {"wrapper":"Dw-z","addressLine":"Ew-z","fullName":"Fw-z"};